export default {"src":"/_next/static/media/retirementcalc.95ba6183.svg","height":89,"width":89,"blurWidth":0,"blurHeight":0};